import {
  showErrorToastMsg,
  showToastMsg,
} from "../../../generic-components/messages/CvpToastMessages";
import { useLocStore } from "../../../localization";
import { LocContext } from "../../../localization/LocContext";
import { useSettings } from "../../../settings/useSettings";
import { useLogOut } from "../../../url/logOut";
import { getRedirectProps } from "../../../url/redirect";
import { useLoginProps } from "../../../url/useLoginProps";
import { useWhoAmI } from "../../../user/useWhoAmI";
import { CustomMenuItem } from "../MenuItems/completeMenuItem";
import { useEnableParameterOverridesMenuItem } from "./useEnableParameterOverridesMenuItem";
import { useLanguageMenuItem } from "./useLanguageMenuItem";
import { useVpnToolsMenuItem } from "./useVpnToolsMenuItem";

export interface UseProfileDepartmentItemsProps {
  showConcernItems?: boolean;
  showMyProfile?: boolean;
  showLogOut?: boolean;
}
export function useProfileDepartmentItems(): CustomMenuItem[] {
  const L = useLocStore(LocContext.PROFILE);
  const { confirmedLoggedIn, confirmedNotLoggedIn, whoAmI } = useWhoAmI();

  const logOut = useLogOut();
  const languageMenuItem = useLanguageMenuItem();
  const settings = useSettings();
  const vpnToolsMenuItem = useVpnToolsMenuItem();

  const enableParameterOverridesMenuItem = useEnableParameterOverridesMenuItem();

  const showLogOut = confirmedLoggedIn;
  const showLogIn = confirmedNotLoggedIn;

  let { redirectProps: loginRedirectProps } = useLoginProps();

  const items: CustomMenuItem[] = [];
  if (!settings?.iframe_overrideLocale) {
    items.push(languageMenuItem);
  }

  if (window.isLocalIp) {
    items.splice(
      0,
      0,
      {
        path: "",
        label: L.id("a2e7c193f5b0").loc("VPN-verktøy"),
        icon: "pi pi-fw pi-wrench",
        className: "vpn-item",
        items: [vpnToolsMenuItem, enableParameterOverridesMenuItem],
        isSelected: () => false,
      } as CustomMenuItem,
      {
        path: "/admin",
        target: "_blank",
        ...getRedirectProps("/admin", {
          mergeQs: {},
          target: "_blank",
        }),
        label: L.id("4e451af785fa").loc("Admin"),
        icon: "pi pi-fw pi-cog",
        className: "vpn-item",
      }
    );
  }

  if (confirmedLoggedIn) {
    items.push({
      path: "/cvpenter",
      label: L.id("e4b0739c1a82").loc("Mine profiler"),
      icon: "pi pi-fw pi-user",
    });
  }

  // Add Manage Account link for Keycloak users (change password, update MFA, etc.)
  if (confirmedLoggedIn && whoAmI.cvpIdp) {
    items.push({
      href: "https://auth.webtemp.no/realms/CVP/account",
      target: "_blank",
      label: L.id("eff82ed2cce0").loc("Administrer konto"),
      icon: "pi pi-fw pi-key",
      isSelected: () => false,
    });
  }

  if (showLogOut) {
    items.push({
      label: L.id("72bd38a1ab66").loc("Logg ut"),
      icon: "pi pi-fw pi-sign-out",
      className: "log-out",
      onClick: logOut,
    });
  }

  if (showLogIn) {
    items.push({
      ...loginRedirectProps,
      label: L.id("a918c8de02b7").loc("Logg inn"),
      icon: "pi pi-fw pi-sign-in",
    });
  }

  if (confirmedLoggedIn) {
    items.push({
      path: "",
      icon: "pi pi-fw pi-copy",
      label: L.id("3acf453f1aec").split("Bruker-ID: {0}", [
        whoAmI?.userIdFromIdentityProvider,
      ]),
      className: "guid",
      onClick: async () => {
        try {
          await navigator.clipboard.writeText(whoAmI?.userIdFromIdentityProvider);
          showToastMsg(L.id("565b477e2a72").loc("Bruker-ID kopiert til utklippstavlen"));
        } catch (err) {
          showErrorToastMsg(err);
          console.log("Something went wrong", err);
        }
      },
    });
  }

  return items;
}
